import axios from 'axios'
import { getLoginShopid } from '@RootCommon/utils'
import { commonRequest } from '@/common/api'
import { getI18nParams } from '@RootCommon/utils'

const I18N_HOST = `https://${process_env_i18nHost}`

function extraI18nQuery (config: any) {
  const { params } = config
  return { ...config, params: { ...params, ...getI18nParams() } }
}
const shopId = getLoginShopid()

const checkShopState = () => commonRequest.get('/api/scm/shop/base/info', { params: { shopId } })

const getUestionnaireUrl = (shopId: number) => commonRequest.post('/merchantapi/order/questionnaire/getUrl', { shopId, apiVersion: 'V2' })

// i18n使用跨域请求
const i18nRequest = axios.create({
  baseURL: I18N_HOST,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
})
// request后面先执行
i18nRequest.interceptors.request.use(extraI18nQuery) // TODO:添加一些固有参数，不需要可删除

export {
  checkShopState,
  getUestionnaireUrl,
  i18nRequest,
}
